import { render, staticRenderFns } from "./NoticeTaskDetail.vue?vue&type=template&id=c318419c&scoped=true&"
import script from "./NoticeTaskDetail.vue?vue&type=script&lang=js&"
export * from "./NoticeTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTaskDetail.vue?vue&type=style&index=0&id=c318419c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c318419c",
  null
  
)

export default component.exports